import {Editor} from '@tiptap/react';
import {EDITOR_MODE, EditorActionTypes, EditorModeType, SET_DEBOUNCE_CHANGE_HANDLER, SET_EDITOR} from '../actions/types/tiptapEditor.types';

export interface EditorState {
    editors: Record<string, Editor>;
    debounceChangeHandlers: Record<string, (updatedContent: string) => void>;
    editorMode: EditorModeType | null;
}

export const editorPreloadedState: EditorState = {
    editors: {},
    debounceChangeHandlers: {},
    editorMode: null,
};

const editorReducer = (state: EditorState = editorPreloadedState, action: EditorActionTypes): EditorState => {
    switch (action.type) {
        case SET_EDITOR:
            return {
                ...state,
                editors: {
                    ...state.editors,
                    [action.payload.id]: action.payload.editor,
                },
            };
        case SET_DEBOUNCE_CHANGE_HANDLER:
            return {
                ...state,
                debounceChangeHandlers: {
                    ...state.debounceChangeHandlers,
                    [action.payload.id]: action.payload.handler,
                },
            };
        case EDITOR_MODE:
            return {
                ...state,
                editorMode: action.payload.mode,
            };
        default:
            return state;
    }
};

export default editorReducer;
